import { DestroyRef, Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SchoolSignupStateService } from './school-signup-state.service';

@Injectable({ providedIn: 'root' })
export class SchoolSignupFlowLifecycleService {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly stateService = inject(SchoolSignupStateService);

  private lastUrl: string = this.router.url ?? '/';

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationStart => e instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((e) => {
        const fromInFlow = this.isSchoolSignupUrl(this.lastUrl);
        const toInFlow = this.isSchoolSignupUrl(e.url);

        // If user leaves the flow (e.g. /school-signup/step3 -> /home), clear the state.
        if (fromInFlow && !toInFlow) {
          this.stateService.reset();
        }

        this.lastUrl = e.url;
      });
  }

  private isSchoolSignupUrl(url: string): boolean {
    // Covers /school-signup, /school-signup/step1, /school-signup/step2, etc.
    return url.startsWith('/school-signup');
  }
}
